import { createFileRoute } from '@tanstack/react-router'

import { FeatureNotAvailable } from '@/components/feature-not-available'

export const Route = createFileRoute('/_authenticated/_general/orders/bag-checks')({
	component: BagChecksPage,
	staticData: {
		crumb: ({ context: { L } }) => L.Orders.BagChecks()
	}
})

function BagChecksPage() {
	return <FeatureNotAvailable />
}
